// removed by extract-text-webpack-plugin
module.exports = {"main":"route-tooltip-main--3pYIT","distance":"route-tooltip-distance--BOWh2","liveTravelTime":"route-tooltip-liveTravelTime--3D8CT","route":"route-tooltip-route--2X8sC","statusText":"route-tooltip-statusText--3Xo_F","speedNumber":"route-tooltip-speedNumber--Kb7QZ","unit":"route-tooltip-unit--3c8Sp","trendIcon":"route-tooltip-trendIcon--2h3uM","routeIcon":"route-tooltip-routeIcon--1DkVI","routeName":"route-tooltip-routeName--1bWZW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/RouteTooltip/route-tooltip.scss
// module id = dki3
// module chunks = 4